// extracted by mini-css-extract-plugin
module.exports = {"container":"HelpSection_container__1gblE","icon":"HelpSection_icon__Cr4I6"};